import React from 'react';
import styles from './Footer.module.css';
import { NavLink } from 'react-router-dom';


function Footer() {
  return (
   <div className={styles.start}>
      <div className={styles.ftr}>
        
        <ul className={styles.social_icon}> 
        <li><a href='#'><ion-icon name="logo-facebook"></ion-icon></a></li>
        <li><a href='#'><ion-icon name="logo-twitter"></ion-icon></a></li>
        <li><a href='#'><ion-icon name="logo-linkedin"></ion-icon></a></li>
        <li><a href='#'><ion-icon name="logo-instagram"></ion-icon></a></li>  
        <li><a href='#'><ion-icon name="logo-youtube"></ion-icon></a></li>       
        </ul>
        <ul className={styles.menu}>
          <li><a href='/'>Home</a></li>
          <li><NavLink to='/about'>About</NavLink></li>
          
          {/* <li><a href='#'>Services</a></li> */}
          {/* <li><a href='#'>team</a></li> */}
          <li><NavLink to='/contact'>contact</NavLink></li>
        </ul>
        <p> All Rights Reserved ©  {new Date().getFullYear()}  Avis</p>
        </div>
    </div>
  );
}

export default Footer;
